import { ISoundItem } from '@/types/sound'
import { setupSoundQueue } from '@/composables/useSoundsStoreData'

export const setupNotification = (notificationData) => {
    const notification = {
        parameterName: notificationData.parameterName,
        current_value: notificationData.currentValue,
        thresholdValue: notificationData.thresholdValue,
        currentStatus: notificationData.currentStatus,
        type: notificationData.type
    }
    const soundItem: ISoundItem = {
        id: notificationData.id,
        sound: notificationData.sound,
        played: notificationData.soundPlayed,
        isPlaying: false,
        timestamp: new Date().getTime(),
        notificationHTML: `The ${notification.currentStatus} of  ${notification.parameterName} is ${notification.thresholdValue}. <br> Current value is ${notification.current_value}.`

    }


    if (soundItem.sound) {
        setupSoundQueue(soundItem)
    }

}
